import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { getLineItemDisplay } from "@babackapp/return-widget-components/utils/line-item-display";
import { getExchangeVariantLabel } from "@babackapp/return-widget-components/utils/exchange-variant-label";
import type {
  DraftLineItem,
  Order,
  OrderLineItem,
} from "@babackapp/return-widget-components/types";

type Props = {
  item: DraftLineItem;
  orderLineItems: OrderLineItem[];
  order: Order | null;
  currency: string;
};

export function CompleteReturnLineItem({
  item,
  orderLineItems,
  order,
  currency,
}: Props) {
  const { title, subtitle, image, price } = getLineItemDisplay(
    orderLineItems,
    item.lineItemId,
  );
  const totalPrice = (price ?? 0) * item.quantity;

  const exchangeLabel =
    item.resolution === "exchange" && item.exchangeVariantId
      ? getExchangeVariantLabel(order, item.lineItemId, item.exchangeVariantId)
      : null;
  const variantDisplay =
    exchangeLabel && subtitle
      ? `${subtitle} → ${exchangeLabel}`
      : (exchangeLabel ?? subtitle);

  return (
    <Article>
      <ArticleImage
        src={image ?? undefined}
        layoutId={`img-complete-${item.lineItemId}`}
      />
      <ArticleTitle>{title}</ArticleTitle>
      <ArticleSubtitle>
        {variantDisplay && `${variantDisplay} · `}×{item.quantity}
        {totalPrice > 0 && ` · ${formatPrice(totalPrice, currency)}`}
      </ArticleSubtitle>
    </Article>
  );
}
